import { fromJS } from 'immutable'
import {
    CONSENT_MANAGEMENT_CREATE_REQUEST ,
    CONSENT_MANAGEMENT_CREATE_SUCCESS ,
    CONSENT_MANAGEMENT_CREATE_FAILURE,
    CONSENT_MANAGEMENT_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONSENT_MANAGEMENT_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case CONSENT_MANAGEMENT_CREATE_SUCCESS:
      return state
        .set('consentCreate', fromJS(action.payload.createdConsent))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('consentCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_CREATE_RESET:
      return state
        .delete('consentCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consent-management/consent-management-create-reducer.js